$(document).ready(function () {
  $(".js-common-input-date-picker").each(function () {
    let input = $(this)

    input.datepicker({
      defaultDate: "1989/01/01",
      dateFormat: "yy/mm/dd",
      changeMonth: true,
      changeYear: true,
      yearRange: "1940:2024",
      monthNames: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      monthNamesShort: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      regional: 'ja',
      dayNamesMin: ["日", "月", "火", "水", "木", "金", "土"],
      onChangeMonthYear: function (year, month, instance) {
        month = month < 10 ? '0' + month : month
        input.val(year + '/' + month + '/01');
      }
    });
  })

  commonFunctions.cleaveDatePicker('js-common-input-date-picker')
})
